import React from "react";
import { Container, Button } from "shards-react";
import api from "../components/common/api";
import { get_request } from "../components/common/axios";
import TopReferrals from "../components/common/TopReferrals";
import { Col, Row } from "shards-react";
import { useEffect, useState } from "react";

function Home() {
    const [data, setData] = useState([]);
    const baseUrl = 'work-orders?id='
    var ids = ''
    const getIds = (data) => {
        var ids = []
        data.forEach(element => {
            ids.push(element.id)
        });
        return ids.join(",")  
    }
    const getDashboard = () => {
        get_request(api.work_order().index_grouped())
        .then(res => {
            if (res.status === 200)
            {
                setData(Object.entries(res.data))
            }
        })
    }

    useEffect(() => getDashboard(), []);

    if (data.length === 0) return <Container fluid className="main-content-container px-4 pb-4"></Container>
    return (
        <Container fluid className="main-content-container px-4 pb-4">
            <Row>
                {(data.map((val,idx)=>{
                    var item = val[1].data
                    var referralData = []
                    var keys = Object.keys(item)
                    keys.forEach(k => referralData.push({title: k, value: item[k].length, ids:getIds(item[k]), link:baseUrl}))
                    referralData.forEach(element => {ids = ids + ',' + element.ids})
                    return (
                        <Col lg="2" sm="12" className="mb-4">
                            <TopReferrals referralData={referralData} title={val[1].title} link={baseUrl} ids={ids}/>
                        </Col>
                    )
                }))}
            </Row>
        </Container>
  )
}

export default Home;
